// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedbacks-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.feedbacks-container .add-modal {
  animation: fadeIn 0.5s;
}
.feedbacks-container .header {
  display: flex;
  align-items: center;
}
.feedbacks-container .header > p {
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  color: var(--secondary-color-1);
  font-size: 20px;
  margin-left: 10px;
}
.feedbacks-container .info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.feedbacks-container .info > p {
  font-family: "Proxima Nova", sans-serif;
  font-size: 16px;
  line-height: 24px;
  width: 800px;
  text-align: center;
  color: var(--secondary-color-1);
}
.feedbacks-container .info > p > span {
  font-weight: 700;
  text-decoration: underline;
}
.feedbacks-container .info > p > span.open-house {
  color: #c86ee5;
}
.feedbacks-container .info > p > span.blackout {
  color: var(--secondary-color-3);
}
.feedbacks-container .drafts-section {
  width: 100%;
}
.feedbacks-container .item-container {
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);
  border-radius: 10px;
  height: 50px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.feedbacks-container .item-container > div {
  display: flex;
  align-items: center;
  flex: 1 1;
}
.feedbacks-container .item-container > div > input[type=checkbox].select {
  margin: 0 !important;
}
.feedbacks-container .item-container > div > img {
  height: 50px;
  width: 50px;
  border-radius: 5px;
  object-fit: cover;
}
.feedbacks-container .item-container > div .line-separator {
  background: var(--primary-color-1);
  border-radius: 5px;
  height: 20px;
  width: 3px;
  margin-right: 10px;
}
.feedbacks-container .item-container > div .details {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  align-items: center;
  width: 100%;
}
.feedbacks-container .item-container > div .details > p {
  margin: 0;
}
.feedbacks-container .item-container > div .details > p.name {
  font-size: 12px;
  font-weight: 700;
  color: var(--secondary-color-3);
  padding-bottom: 3px;
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.feedbacks-container .item-container > div .details > p.name > svg {
  margin-left: 5px;
}
.feedbacks-container .item-container > div .details > p.address {
  flex: 3 1;
  font-weight: 700;
  font-size: 14px;
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--secondary-color-1);
}
.feedbacks-container .item-container > div .details .time {
  flex: 1 1;
  align-self: flex-end;
  font-weight: 600;
  font-size: 12px;
  text-align: right;
  color: var(--secondary-color-3);
}
.feedbacks-container .item-container p.continue {
  background: #D9D9D9;
  border-radius: 5px;
  padding: 0px 22px;
  font-weight: 500;
  font-size: 10px;
  color: var(--secondary-color-1);
  transition: 0.3s ease-in-out;
  cursor: pointer;
  display: flex;
  height: 30px;
  align-items: center;
}
.feedbacks-container .item-container p.continue:hover {
  opacity: 0.75;
}
.feedbacks-container .item-container .delete {
  cursor: pointer;
  background-color: #FF3535;
  padding: 0px 10px;
  display: flex;
  height: 30px;
  align-items: center;
  border-radius: 5px;
  transition: 0.3s ease-in-out;
  margin-left: 10px;
}
.feedbacks-container .item-container .delete:hover {
  opacity: 0.75;
}
.feedbacks-container .empty {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  color: var(--secondary-color-3);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingFeeback/modules/Feedbacks/feedbacks.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAGI;EACI,sBAAA;AADR;AAGI;EACI,aAAA;EACA,mBAAA;AADR;AAEQ;EACI,SAAA;EACA,uCAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAEQ;EACI,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAAZ;AACY;EACI,gBAAA;EACA,0BAAA;AAChB;AAAgB;EACI,cAAA;AAEpB;AAAgB;EACI,+BAAA;AAEpB;AAGI;EACI,WAAA;AADR;AAGI;EACI,mBAAA;EACA,kDAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAAZ;AACY;EACI,oBAAA;AAChB;AACY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAChB;AACY;EACI,kCAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAChB;AACY;EACI,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAChB;AAAgB;EACI,SAAA;AAEpB;AADoB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAGxB;AAFwB;EACI,gBAAA;AAI5B;AADoB;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;AAGxB;AAAgB;EACI,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AAEpB;AAEQ;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AACY;EACI,aAAA;AAChB;AAEQ;EACI,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;AAAZ;AACY;EACI,aAAA;AAChB;AAGI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AADR;AAGI;EACI;IAAK,UAAA;EAAX;EACM;IAAO,UAAA;EAEb;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n\r\n.feedbacks-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    .add-modal {\r\n        animation: fadeIn .5s;\r\n    }\r\n    .header {\r\n        display: flex;\r\n        align-items: center;\r\n        > p {\r\n            margin: 0;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            font-size: 20px;\r\n            margin-left: 10px;\r\n        }\r\n    }\r\n    .info {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        > p {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n            width: 800px;\r\n            text-align: center;\r\n            color: var(--secondary-color-1);\r\n            > span {\r\n                font-weight: 700;\r\n                text-decoration: underline;\r\n                &.open-house {\r\n                    color: #c86ee5;\r\n                }\r\n                &.blackout {\r\n                    color: var(--secondary-color-3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .drafts-section {\r\n        width: 100%;\r\n    }\r\n    .item-container {\r\n        background: #FFFFFF;\r\n        box-shadow: 0px 4px 20px rgba(129, 159, 188, 0.15);\r\n        border-radius: 10px;\r\n        height: 50px;\r\n        padding: 15px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        margin-bottom: 20px;\r\n        > div {\r\n            display: flex;\r\n            align-items: center;\r\n            flex: 1;\r\n            > input[type=checkbox].select {\r\n                margin: 0 !important;\r\n            }\r\n            > img {\r\n                height: 50px;\r\n                width: 50px;\r\n                border-radius: 5px;\r\n                object-fit: cover;\r\n            }\r\n            .line-separator {\r\n                background: var(--primary-color-1);\r\n                border-radius: 5px;\r\n                height: 20px;\r\n                width: 3px;\r\n                margin-right: 10px;\r\n            }\r\n            .details {\r\n                font-family: 'Proxima Nova', sans-serif;\r\n                display: flex;\r\n                align-items: center;\r\n                width: 100%;\r\n                > p { \r\n                    margin: 0;\r\n                    &.name {\r\n                        font-size: 12px;\r\n                        font-weight: 700;\r\n                        color: var(--secondary-color-3);\r\n                        padding-bottom: 3px;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        padding-right: 10px;\r\n                        > svg {\r\n                            margin-left: 5px;\r\n                        }\r\n                    }\r\n                    &.address {\r\n                        flex: 3;\r\n                        font-weight: 700;\r\n                        font-size: 14px;\r\n                        max-width: 500px;\r\n                        white-space: nowrap;\r\n                        overflow: hidden;\r\n                        text-overflow: ellipsis;\r\n                        color: var(--secondary-color-1);\r\n                    }\r\n                }\r\n                .time {\r\n                    flex: 1;\r\n                    align-self: flex-end;\r\n                    font-weight: 600;\r\n                    font-size: 12px;\r\n                    text-align: right;\r\n                    color: var(--secondary-color-3);\r\n                }\r\n            }\r\n        }\r\n        p.continue {\r\n            background: #D9D9D9;\r\n            border-radius: 5px;\r\n            padding: 0px 22px;\r\n            font-weight: 500;\r\n            font-size: 10px;\r\n            color: var(--secondary-color-1);\r\n            transition: .3s ease-in-out;\r\n            cursor: pointer;\r\n            display: flex;\r\n            height: 30px;\r\n            align-items: center;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n        }\r\n        .delete {\r\n            cursor: pointer;\r\n            background-color: #FF3535;\r\n            padding: 0px 10px;\r\n            display: flex;\r\n            height: 30px;\r\n            align-items: center;\r\n            border-radius: 5px;\r\n            transition: .3s ease-in-out;\r\n            margin-left: 10px;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n        }\r\n    }\r\n    .empty {\r\n        text-align: center;\r\n        font-weight: 700;\r\n        font-size: 24px;\r\n        color: var(--secondary-color-3);\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet) { \r\n    .image-view-container {\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
